import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqFn;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: FbqFn;
    _fbq?: FbqFn;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  /* Meta Pixel Code */
  useEffect(() => {
    if (window.fbq) return;
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
    } as FbqFn;
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    n('init', PIXEL_ID);
    n('track', 'PageView');
  }, []);
  /* End Meta Pixel Code */

  return <div className="min-h-screen w-full bg-white font-sans text-navy antialiased selection:bg-sol selection:text-navy" data-id="element-0" data-mp="nvj179a902mk">
      <noscript data-id="element-1" data-mp="stue5svuat90">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="stkj3qvxtvwg" />
      </noscript>

      <Hero data-id="element-3" data-mp="3ucjc5sple9t7" />
      <main data-id="element-4" data-mp="3uevq7us8c00z">
        <ProblemSection data-id="element-5" data-mp="d4nxjm8nzu51" />
        <SolutionSection data-id="element-6" data-mp="d57fh2ybeij2" />
        <BonusesSection data-id="element-7" data-mp="d3cw3t2oyyh3" />
        <BenefitsSection data-id="element-8" data-mp="d2l936n5u92f" />
        <OfferSection data-id="element-9" data-mp="85uihpdqbv2r" />
        <GuaranteeSection data-id="element-10" data-mp="85bd1859mz5m" />
        <Testimonials data-id="element-11" data-mp="8648hcyry28g" />
        <FAQSection data-id="element-12" data-mp="83i6rtykegy5" />
        <FinalCTA data-id="element-13" data-mp="3gl4rzijy82kk" />
      </main>
      <Footer data-id="element-14" data-mp="3gmfu7dxqx29k" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="3gja7u6gi4ehj" />}
    </div>;
}